export default __webpack_public_path__ + "static/media/devocean-solutions.9d5a2c29.png";